<template>
  <div>
    <h3 class="m-0 mb-xxs">
      {{ attachable_category.name || '' }}
    </h3>
    <dd-main-table
        v-if="pagination"
        :headers="headers"
        :rows="attachables"
        :skeletonRowLength="attachable_category.attachable_count.data.count"
        :rounded="true"
        :entireRowSelects="true"
        :selectedFromRow="true"
        :keepSelectedAfterPageChange="true"
        :paginator="pagination"
        :initialLoadPageObject="pagination"
        :selected="selectedDocuments"
        @load-page="loadPage"
        @update-selected="(documents) => $emit('selectDocuments', documents)"
    />
  </div>
</template>

<script>
import AttachableApi from '~/api/attachable';
import DateCell from "~/new_design_components/tables/cell_types/DateCell.vue";
import DocumentIconCell from "~/new_design_components/tables/cell_types/DocumentIconCell.vue";

export default {
  name: "SelectDocumentTableComponent",
  emits: ['cancel', 'input'],
  props:{
    attachable_category:{
      value: Object,
      required: true
    },
    selectedDocuments: {
      type: Array
    }
  },
  data(){
    return {
      headers: [
        {title: '', key: '', typeComponent: DocumentIconCell, width: '22px'},
        {title: 'Naam', key: 'name'},
        {title: 'Datum', key: 'created_at', typeComponent: DateCell, width: '125px'}
      ],
      attachables: [],
      pagination: undefined,
      loading: false
    }
  },
  mounted(){
    this.getAttachables();
  },
  methods:{
    async getAttachables(){
      const { data, meta } = await AttachableApi.getByAttachableCategoryId(
          this.attachable_category.id,
          this.pagination?.page,
          this.pagination?.perPage,
          this.pagination?.orderBy || 'created_at',
          this.pagination?.order || 'desc',
          ["child_instance"]
      );
      this.attachables = data;
      this.pagination = meta.pagination;
    },
    loadPage(paginationObject){
      this.pagination = paginationObject;
      this.getAttachables();
    }
  },
  computed: {

  },
};
</script>
<style lang="scss" scoped>
@import "~@/_default.scss";
</style>